export enum AccountType {
  qq = 'qq',
  wx = 'wx',
  notlogin = ''
}

export interface TypeUserService {
  isInited: boolean;
  /** 昵称 */
  nick: string;
  /** 头像 */
  headurl: string;
  /** 账号类型 wx 或 qq */
  type: AccountType;
  /** uin 或者 openId */
  id: string;
  /** vuid */
  vuid: number;
  init(): Promise<void>;
  refresh(): Promise<void>;
}
